"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function fil(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.5695 9.51382C11.8485 8.34157 12.1845 7.28782 12.5415 6.60007C12.6727 6.27157 13.2052 5.48482 13.7895 4.96507C14.7622 4.09882 15.8535 3.87907 16.9897 4.59232L16.89 4.75057L16.9897 4.59232C17.5695 4.95607 17.802 5.33032 17.7 5.68282C17.625 5.94532 17.3377 6.15532 17.184 6.13357C16.959 6.15607 16.7325 6.11107 16.5165 5.95207C16.3346 5.81201 16.1944 5.62507 16.1107 5.41132C15.9517 5.03632 15.7432 4.90882 15.4875 4.93882C15.3022 4.95982 15.087 5.07832 15.0187 5.15782L14.8425 5.35282C14.7055 5.49871 14.5838 5.6583 14.4795 5.82907C14.1225 6.42382 13.7932 7.51357 13.3365 9.77182L16.3635 10.2151L16.197 11.4278L13.125 10.9778L12.9937 11.7758L12.96 11.9753C12.942 12.0788 12.9225 12.1913 12.9 12.3113L16.002 12.7658L15.8242 13.9771L12.6495 13.5121C12.2827 15.0706 11.7997 16.7408 11.4585 17.4001C11.3265 17.7293 10.7947 18.5146 10.2105 19.0351C9.23773 19.9006 8.14648 20.1211 7.01023 19.4078C6.43048 19.0441 6.19799 18.6691 6.29999 18.3166C6.37499 18.0541 6.66224 17.8448 6.81599 17.8666C7.04098 17.8441 7.26749 17.8891 7.48349 18.0473C7.64999 18.1703 7.78798 18.3488 7.88923 18.5888C8.04823 18.9631 8.25674 19.0913 8.51249 19.0613C8.69774 19.0396 8.91299 18.9211 8.98124 18.8416C9.66148 18.0841 10.2007 16.6246 10.8825 13.2541L7.85548 12.8101L8.02198 11.5973L11.094 12.0473L11.226 11.2501C11.2552 11.071 11.2864 10.8922 11.3197 10.7138L8.22974 10.2616L8.40674 9.05032L11.5695 9.51382Z", fill: color }));
}
exports["default"] = fil;
//# sourceMappingURL=fil.js.map